<!--<alert type="info" class="text-center banner">Our office will be closed on Monday, May 25th in observance of Memorial Day. We will resume normal business hours on Tuesday, May 26th.</alert>-->
<router-outlet></router-outlet>
<alert
      style="position: fixed; top: 4px; right: 4px ; z-index: 1000;"
      [dismissible]="alertService.dismissible()"
      [isOpen]="alertService.alertOpen()"
      [type]="alertService.alertType()"
      [dismissOnTimeout]="alertService.alertTimeout()"
      (onClosed)="alertService.alertOpen.set(false)"
    >
      <span class="pe-5"> {{ alertService.alertMsg() }} </span>
    </alert>
